module.exports = __webpack_public_path__ + "img/热浪岛.f95de424.jpg";